var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 4.5V8.5H10.5V4.5H4.5ZM4 3C3.44772 3 3 3.44772 3 4V9C3 9.55228 3.44772 10 4 10H11C11.5523 10 12 9.55228 12 9V4C12 3.44772 11.5523 3 11 3H4Z",
    fill: "#8C8C8C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5 21.5L21.5 17.5L15.5 17.5L15.5 21.5L21.5 21.5ZM22 23C22.5523 23 23 22.5523 23 22L23 17C23 16.4477 22.5523 16 22 16L15 16C14.4477 16 14 16.4477 14 17L14 22C14 22.5523 14.4477 23 15 23L22 23Z",
    fill: "#8C8C8C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 21.5L10.5 13.5L4.5 13.5L4.5 21.5L10.5 21.5ZM11 23C11.5523 23 12 22.5523 12 22L12 13C12 12.4477 11.5523 12 11 12L4 12C3.44772 12 3 12.4477 3 13L3 22C3 22.5523 3.44772 23 4 23L11 23Z",
    fill: "#8C8C8C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 4.5L15.5 12.5L21.5 12.5L21.5 4.5L15.5 4.5ZM15 3C14.4477 3 14 3.44772 14 4L14 13C14 13.5523 14.4477 14 15 14L22 14C22.5523 14 23 13.5523 23 13L23 4C23 3.44771 22.5523 3 22 3L15 3Z",
    fill: "#8C8C8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardMenuIcon);
export default __webpack_public_path__ + "static/media/dashboard-menu-icon.16ffdaaf8151374474ccb79b79b01e7f.svg";
export { ForwardRef as ReactComponent };